import BaseObject from '../../../base/base_object';

export default class OAuth2State extends BaseObject {
    static CLASS = 'OAuth2State';

    init(params) {
        super.init(params);
    }

    isAuthorized() {
        this.throwNotImplemented('11', 'isAuthorized');
    }

    tryToRememberMe() {
        this.throwNotImplemented('15', 'tryToRememberMe');
    }

    login(credentials) {
        this.throwNotImplemented('19', 'login');
    }

    logout() {
        this.throwNotImplemented('23', 'logout');
    }

    getLoginType() {
        this.throwNotImplemented('27', 'getLoginType');
    }

    autologinWithToken(token, sessionTimerOffset, sourceProductPackage) {
        this.throwNotImplemented('31', 'autologinWithToken');
    }

    getDecodedAccessToken() {
        this.throwNotImplemented('35', 'getDecodedAccessToken');
    }

    getTokenAuthorizeHeader() {
        this.throwNotImplemented('39', 'getTokenAuthorizeHeader');
    }

    getRefreshToken() {
        this.throwNotImplemented('43', 'getRefreshToken');
    }

    extractTokenProperty(tokenProperty) {
        this.throwNotImplemented('47', 'extractTokenProperty');
    }

    isVIP() {
        this.throwNotImplemented('51', 'isVIP');
    }

    getUserData() {
        this.throwNotImplemented('55', 'getUserData');
    }

    getAccountData() {
        this.throwNotImplemented('59', 'getAccountData');
    }

    updateTokenData(filedName, fieldValue) {
        this.throwNotImplemented('63', 'updateTokenData');
    }

    refreshToken() {
        this.throwNotImplemented('67', 'refreshToken');
    }

    getTimeSinceLogin() {
        this.throwNotImplemented('71', 'getTimeSinceLogin');
    }

    onInitComplete(fromOnInitCompleteEvent) {
        this.throwNotImplemented('75', 'onInitComplete');
    }
}